module.exports = __webpack_public_path__ + "media/images/lb/122-1a02d5e2ccb6026d2236554023ed94f4.svg";